// extracted by mini-css-extract-plugin
module.exports = {"tab":"index_tab__1JUc1","mark__div":"index_mark__div__1jhFI","mark__left__div":"index_mark__left__div__2I-Yv","mark__right__div":"index_mark__right__div__25x1y"};